<template>
  <div>
    <h2>Not Found</h2>
    <p>Whoops! Looks like the page you requested cannot be found.</p>
  </div>
</template>